/**
 * Global Show more / Load more
 * Uses Shopify Section Rendering API. Container and item selectors
 * come from the button so collection, search, blog, and list pages all work.
 */
(function () {
  if (window.__collectionLoadMoreBound) return;
  window.__collectionLoadMoreBound = true;

  var SELECTOR = '[data-load-more]';

  document.addEventListener('click', function (event) {
    var button = event.target.closest(SELECTOR);
    if (!button) return;

    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    loadNextPage(button);
  });

  function loadNextPage(button) {
    var containerSelector = button.getAttribute('data-load-more-container') || '#product-grid';
    var itemSelector = button.getAttribute('data-load-more-item') || '.grid__item';
    var grid = findGrid(button, containerSelector);
    var nextUrl = button.getAttribute('data-next-url') || button.getAttribute('href');
    if (!grid || !nextUrl) return;

    var sectionId = button.getAttribute('data-section-id') || grid.getAttribute('data-id');
    var requestUrl = buildSectionUrl(nextUrl, sectionId);

    setLoading(button, true);

    fetch(requestUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Load more failed');
        return response.text();
      })
      .then(function (html) {
        if (!grid.isConnected) return;
        appendItems(grid, html, button, containerSelector, itemSelector);
      })
      .catch(function (error) {
        console.error('[load-more]', error);
        if (button.isConnected) setLoading(button, false);
      });
  }

  function findGrid(button, selector) {
    var section = button.closest('.shopify-section');
    if (section) {
      var scoped = section.querySelector(selector);
      if (scoped) return scoped;
    }
    return document.querySelector(selector);
  }

  function buildSectionUrl(nextUrl, sectionId) {
    var url = new URL(nextUrl, window.location.href);
    if (sectionId) url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function appendItems(grid, html, button, containerSelector, itemSelector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newGrid = doc.querySelector(containerSelector);
    if (!newGrid) {
      setLoading(button, false);
      return;
    }

    var items = Array.prototype.filter.call(newGrid.children, function (el) {
      return el.matches(itemSelector);
    });

    items.forEach(function (item, index) {
      item.classList.add('is-ajax-appended', 'scroll-trigger--cancel');
      item.style.setProperty('--load-more-order', String(index));
      grid.appendChild(item);
    });

    updateButton(button, doc);
  }

  function updateButton(button, doc) {
    var nextButton = doc.querySelector(SELECTOR);
    var wrapper = button.closest('.collection-load-more');

    if (!nextButton) {
      if (wrapper) wrapper.remove();
      return;
    }

    var nextUrl = nextButton.getAttribute('data-next-url') || nextButton.getAttribute('href');
    button.setAttribute('href', nextUrl);
    button.setAttribute('data-next-url', nextUrl);
    setLoading(button, false);
  }

  function setLoading(button, isLoading) {
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    button.classList.toggle('is-loading', isLoading);

    var spinner = button.querySelector('.collection-load-more__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }
})();
